

import Categories from '../../../store/categories';

angular
    .module('festzelt-os.categories')
    .factory('Categories', [
        '$injector',
        'Category',
        ($injector, Category) => new Categories(Category, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/categories/store/categories.js